<template>
    <div class="wrapper">
        <div class="contentBox">
            <leftMenu v-if="showLeftMenu"></leftMenu>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import leftMenu from './leftMenu.vue'

    export default {
        name: "home",
        components: {
            leftMenu
        },
        computed: {
            showLeftMenu() {
                return !['/invoiceCreate', '/invoiceUpdate', '/createEstimate', '/updateEstimate'].includes(this.$route.path);
            }
        }
    }
</script>

<style scoped>
    /* 框架定位等 */
    .contentBox {
        width: 100%;
        display: flex;
        height: 100%;
        position: absolute;
    }

    .contentBox > .el-container {
        flex: 1;
        min-width: 0;
    }
</style>
